import { frame } from "assets";
import styled from "styled-components";

export const MainSection = styled.section`
  padding-bottom: 8rem;

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    margin-top: 1.5rem;
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const TextBoxDiv = styled.div`
  margin-top: 2rem;
  position: relative;
  width: 37.5625rem;
  height: 5.5rem;

  @media (max-width: 1600px) {
    width: 25.5625rem;
  }

  @media (max-width: 600px) {
    width: 300px;
  }

  img {
    width: 100% !important;
    height: 100% !important;
  }

  div {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 2rem;
    h1 {
      margin: 0;
      color: #fff;
      font-size: 50px;
      font-style: italic;
      font-weight: 400;
      line-height: 77px;
      letter-spacing: -0.02em;

      span {
        color: rgba(247, 193, 58, 1);
        font-family: "Space Crusaders" !important ;
      }

      @media (max-width: 1600px) {
        font-size: 2.125rem;
      }
      @media (max-width: 767px) {
        font-size: 1.24063rem;
      }
    }
  }
`;

export const Text = styled.p`
  color: #fff;
  text-align: center;
  font-family: "Inter";
  font-size: 36px;
  font-style: italic;
  font-weight: 600;
  line-height: normal;
  margin-top: -1rem;

  @media (max-width: 990px) {
    font-size: 16px;
    padding: 0rem 1rem;
  }
`;

export const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MainDiv = styled.div`
  position: relative;
  width: 1193.928px;
  height: 382.784px;
  .summarimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 990px) {
    width: 100%;
    height: 112.213px;
  }
`;

export const MainDivContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  gap: 1rem;
  .first-div {
    display: flex;
    align-items: center;
    gap: 3rem;

    @media (max-width: 990px) {
      gap: 1rem;
      img {
        width: 45.161px;
        height: 45.161px;
      }
    }
  }

  .content-text {
    h1 {
      color: #f7c13a;
      font-size: 53.491px;
      font-style: italic;
      font-weight: 400;
      letter-spacing: -1.07px;
      margin-bottom: 0rem;

      @media (max-width: 990px) {
        font-size: 15.681px;
      }
    }

    h2 {
      color: #fff;
      font-family: "Space Crusaders" !important;
      font-size: 53.491px;
      font-style: italic;
      font-weight: 400;
      letter-spacing: -1.07px;
      margin-bottom: 0rem;

      @media (max-width: 990px) {
        font-size: 15.681px;
      }
    }

    p {
      color: #f7c13a;
      font-family: "Inter";
      font-size: 25.676px;
      font-style: italic;
      font-weight: 600;
      line-height: normal;
      text-transform: capitalize;

      @media (max-width: 990px) {
        font-size: 10.527px;
      }
    }
  }

  @media (max-width: 990px) {
    .divider-img {
      display: none;
    }
  }

  @media (min-width: 990px) {
    .mdivider-img {
      display: none;
    }
  }
`;

export const TopMainDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;

  @media (max-width: 990px) {
    margin-top: 1.5rem;
  }
`;

export const AvailableMainSection = styled.section`
  margin-top: 6rem;

  @media (max-width: 990px) {
    margin-top: 3rem;
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 371px;
  height: 610.5px;
  margin-top: 3rem;

  @media (max-width: 400px) {
    width: 100%;
  }

  .innerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;

export const CardInnerDiv = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 1.7rem;

  .mask1 {
    -webkit-mask-image: url(${frame});
    mask-image: url(${frame});
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
  }

  @media (max-width: 767px) {
    padding: 2rem 2rem;
  }

  h1 {
    color: #fff;
    font-size: 24px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    margin-top: 0.5rem;
  }

  .content-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.7rem;
    h5 {
      color: #8e8c8c;
      font-family: "Inter" !important;
      font-size: 17.444px;
      font-style: italic;
      font-weight: 500;
      line-height: normal;
      margin: 0;
    }

    p {
      text-align: right;
      font-family: "Inter" !important;
      font-size: 17.444px;
      font-style: italic;
      font-weight: 600;
      line-height: normal;
      background: var(
        --yellow,
        linear-gradient(180deg, #e0c528 0%, #f7c13a 100%)
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 0;
    }
  }

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 316.11px;
    height: 51.88px;
    margin-top: 0.8rem;

    @media (max-width: 767px) {
      width: 300px;
    }

    h1 {
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
      margin-top: 0rem !important;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .register-btn-div2 {
    cursor: pointer;
    position: relative;
    width: 316.11px;
    height: 55.88px;
    margin-top: 0.8rem;

    @media (max-width: 767px) {
      width: 300px;
    }

    .main-div {
      position: relative;
      margin-top: 1rem;
    }

    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      letter-spacing: 0em;
      color: #515151;
      text-align: center;
      width: 100%;
      padding-top: 0.5rem;
      margin-bottom: 0rem;
    }

    p {
      font-size: 16px;
      font-style: italic;
      font-weight: 600;
      margin-bottom: 0rem;
      letter-spacing: 0em;
      color: #515151;
      text-align: center;
      width: 100%;
      margin-top: 0rem !important;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 0.2rem;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .register-btn-div3 {
    cursor: pointer;
    position: relative;
    width: 316.11px;
    height: 55.88px;
    margin-top: 0.8rem;

    @media (max-width: 767px) {
      width: 300px;
    }

    .main-div {
      position: relative;
      margin-top: 1rem;
    }

    h1 {
      font-size: 20px;
      font-style: italic;
      font-weight: 400;
      letter-spacing: 0em;
      color: #515151;
      text-align: center;
      width: 100%;
      padding-top: 1rem;
      margin-bottom: 0rem;
    }

    p {
      font-size: 16px;
      font-style: italic;
      font-weight: 600;
      margin-bottom: 0rem;
      letter-spacing: 0em;
      color: #515151;
      text-align: center;
      width: 100%;
      margin-top: 0rem !important;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 0.2rem;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const MyStakingSection = styled.section`
  margin-top: 5rem;
`;

export const Contentdiv = styled.div`
  margin-top: 3rem;
  @media (max-width: 767px) {
    margin-top: 1rem;
  }

  .main-question-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .answer-div {
    padding-left: 4rem;
    margin-top: 0.5rem;

    @media (max-width: 767px) {
      padding-left: 2rem;
      margin-top: 0rem;
    }
    h5 {
      color: rgba(255, 255, 255, 1);
      font-size: 24px;
      font-style: italic;
      font-weight: 500;
      line-height: 35px;
      letter-spacing: 0.06em;
      text-align: left;
      white-space: pre-line;
      @media (max-width: 767px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

export const MainDiv1 = styled.div`
  padding: 1rem 0.5rem;
  &.open-div {
    background: rgba(69, 52, 11, 1);
  }

  @media (max-width: 767px) {
    padding: 0.3rem 0.5rem;
  }
`;

export const FaqSection = styled.section`
  margin-top: 6rem;
  .number-div {
    width: 38px;
    height: 39px;
    border: 1px solid rgba(247, 193, 58, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 767px) {
      width: 20.626px;
      height: 21.037px;
    }
    h1 {
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 50px;
      letter-spacing: -0.02em;
      color: rgba(255, 255, 255, 1);
      margin: 0;

      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
  }

  h4 {
    font-size: 32px;
    font-style: italic;
    font-weight: 600;
    line-height: 46px;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 1);
    margin: 0;

    @media (max-width: 767px) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .question-div {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    @media (max-width: 767px) {
      gap: 0.5rem;
      margin-top: 1rem;
    }
  }
`;

export const TextBoxDiv2 = styled.div`
  margin-top: 2rem;
  position: relative;
  width: 40.5625rem;
  height: 5.5rem;

  @media (max-width: 1600px) {
    width: 40.5625rem;
  }

  @media (max-width: 600px) {
    width: 300px;
  }

  img {
    width: 100% !important;
    height: 100% !important;
  }

  div {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 5rem;

    @media (max-width: 767px) {
      padding-right: 2rem;
    }
    h1 {
      margin: 0;
      color: #fff;
      font-size: 2.125rem;
      font-style: italic;
      font-weight: 400;
      line-height: 77px;
      letter-spacing: -0.02em;

      span {
        color: rgba(247, 193, 58, 1);
        font-family: "Space Crusaders" !important ;
      }

      @media (max-width: 1600px) {
        font-size: 2.125rem;
      }
      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
  }
`;

export const CloseDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;
  padding: 1.5rem;

  img {
    cursor: pointer;
  }
`;
